import { useMutation } from "react-query";
import { createClinicalApproach, updateClinicalApproach } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

const useSaveClinicalApproach = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({
      clientId,
      recordId,
      payload,
    }: {
      clientId: number;
      recordId?: number;
      payload: Record<string, any>;
    }) =>
      recordId
        ? updateClinicalApproach(recordId, payload)
        : createClinicalApproach(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving clinical approach.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    saveClinicalApproachMutation: mutate,
    isSaveClinicalApproachLoading: isLoading,
    ...rest,
  };
};

export default useSaveClinicalApproach;
